export default "__VITE_ASSET__88004661__"